import { useQuery } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useProfileScorecard = () => {
  const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  return useQuery({
    queryKey: ['profileScorecard'],
    queryFn: async () => {
      const url = `${prefix}/profile-scorecards`;
      const result = await restClient({ url });
      return result;
    },
    staleTime: 0,
    cacheTime: 0,
  });
};
